import useFetchQrCodeAdmin from '@shared/hooks/useFetchQrCodeAdmin';
import { QrCode } from '@shared/ui/qr-code';
import { PreloaderCircular } from '@shared/ui/kit';
import * as stylex from '@stylexjs/stylex';
import { FC } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { styles } from './styles';

export const QrPageAdmin: FC = () => {
  const { hash } = useParams();
  const { data, fetching, error } = useFetchQrCodeAdmin(hash ?? '', 261);

  if (fetching)
    return (
      <div {...stylex.props(styles.preloaderContainer)}>
        <PreloaderCircular variant="secondary" />
      </div>
    );
  if (error) return <Navigate to="/error" />;

  return (
    <div {...stylex.props(styles.container)}>
      {data?.getAuthQrcodeByUserId && (
        <>
          <QrCode svg={data.getAuthQrcodeByUserId} />
          <p {...stylex.props(styles.title)}>Ваш QR</p>
        </>
      )}
    </div>
  );
};
